import { Checkbox, Collapse } from 'antd';

import { ReactComponent as CancelIcon } from './../../../../../assets/svg/cancel.svg';
import useFilterSidebar from './useFilterSidebar';

const FilterSidebar = ({
  filter_open,
  set_filter_open,
  filter_list = [],
  checkbox_change,
  clear_filter,
  submit_filter
}) => {
  const [sidebar_ref] = useFilterSidebar(filter_open, set_filter_open);

  return (
    <>
      <div className={`filter-sidebar-backdrop ${filter_open ? 'active' : ''}`} />

      <div ref={sidebar_ref} className={`filter-sidebar ${filter_open ? 'active' : ''}`}>
        <div className="filter-sort-top-nav">
          <button className="clear-filter-button" onClick={() => clear_filter()} type="button">
            لغو همه فیلترها
          </button>
          <div className="cancel-icon-wrapper" onClick={() => set_filter_open(false)}>
            <CancelIcon />
          </div>
        </div>
        <div className="collapse-container-parent">
          <Collapse className="collapse-container">
            {filter_list.map((filter_item, filter_item_index) => {
              if (filter_item.type === 'collapse') {
                return (
                  <Collapse.Panel
                    key={filter_item.key}
                    className="collapse-panel"
                    header={filter_item.label}>
                    <div className="checkboxes-container">
                      {filter_item.list.map((sub_item, sub_item_index) => (
                        <Checkbox
                          key={sub_item_index}
                          checked={sub_item.active}
                          className="checkbox-style"
                          onChange={(e) => {
                            checkbox_change(filter_item_index, sub_item_index, e.target.checked);
                          }}>
                          {sub_item.label}
                        </Checkbox>
                      ))}
                    </div>
                  </Collapse.Panel>
                );
              }
              return null;
            })}
          </Collapse>
        </div>
        <div className="submit-filter-button-container">
          <button className="submit-filter-button" onClick={() => submit_filter()} type="button">
            فیلتر کن
          </button>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;
